export enum ConversationResponseCloseAndDeleteError {
  invalidConversationLogId = 'invalidConversationLogId',
  alreadyClosed = 'alreadyClosed',
  unableToGetConversation = 'unableToGetConversation',
  unableToCloseConversation = 'unableToCloseConversation',
  cannotCreateTask = 'cannotCreateTask',
}
